import { render, staticRenderFns } from "./OrderNotificationToggle.vue?vue&type=template&id=25640394&scoped=true&"
import script from "./OrderNotificationToggle.vue?vue&type=script&lang=js&"
export * from "./OrderNotificationToggle.vue?vue&type=script&lang=js&"
import style0 from "./OrderNotificationToggle.vue?vue&type=style&index=0&id=25640394&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25640394",
  null
  
)

export default component.exports